// Refs: https://viblo.asia/p/full-width-and-half-width-check-with-angular-4-javascript-V3m5WOpx5O7
export const fullWidthLength = (string: string) => {
  let r = 0;
  for (let i = 0; i < string.length; i += 1) {
    const c = string.charCodeAt(i);
    // Shift_JIS: 0x0 ～ 0x80, 0xa0 , 0xa1 ～ 0xdf , 0xfd ～ 0xff
    // Unicode : 0x0 ～ 0x80, 0xf8f0, 0xff61 ～ 0xff9f, 0xf8f1 ～ 0xf8f3
    if (
      (c >= 0x0 && c < 0x81)
      || (c === 0xf8f0)
      || (c >= 0xff61 && c < 0xffa0)
      || (c >= 0xf8f1 && c < 0xf8f4)
    ) {
      r += 1;
    } else {
      r += 2;
    }
  }
  return r;
};

export const padLeft = (str: string, lenght: number): string => {
  if (str.length >= lenght) return str;
  return padLeft(`0${str}`, lenght);
};

export const padRight = (str: string, lenght: number): string => {
  if (str.length >= lenght) return str;
  return padRight(`${str}0`, lenght);
};

export const generateId = (length = 4) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  let result = '';

  for (let i = 0; i < length; i += 1) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

export const generateSerialId = ((index = 0) => () => (index + 1).toString())();
